// ==============================|| MENU ITEMS - BANNER ROUTES ||============================== //
import AdsClickIcon from '@mui/icons-material/AdsClick';

const BannerRoutes = {
  id: 'Banner-group',
  title: 'Banner Management',
  type: 'group',
  children: [
    {
      id: 'Banner-list',
      title: 'Banner List',
      type: 'item',
      url: '/banner/list',
      icon: AdsClickIcon,
      target: false
    }
  ]
};

export default BannerRoutes;
